import type { ReactNode } from 'react';

import { useCompanyFromUrl } from '~/session/companyFromUrl';

interface CompanyFromUrlProps {
  children: ReactNode;
}

/**
 * Põe em operação a empresa do `?empresa=<id>` (o toque num push, `useCompanyFromUrl`) antes da
 * tela. Fica por fora do `RequireModule`, para o guarda já ler o nível na empresa nova: quem toca
 * no push de uma empresa com `documents` `READ` tendo selecionada outra sem acesso chega à tela, e
 * quem não tem o nível na empresa do push volta ao painel, como sem o parâmetro.
 */
export function CompanyFromUrl({ children }: CompanyFromUrlProps): JSX.Element {
  const switching = useCompanyFromUrl();

  if (switching) {
    return <></>;
  }

  return <>{children}</>;
}
